module.exports = __webpack_public_path__ + "static/media/ducted.6e2b795c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ducted.png
// module id = 155
// module chunks = 0